/**
 * 时间问候语工具函数
 * 根据当前时间生成相应的问候语
 */

import { getCurrentTimezoneOffset } from './getCurrentTimezoneOffset';

// 时间段枚举
export enum TimeOfDay {
  MORNING = 'morning',     // 6:00-11:59
  AFTERNOON = 'afternoon', // 12:00-17:59
  EVENING = 'evening',     // 18:00-22:59
  LATE_NIGHT = 'lateNight' // 23:00-5:59
}

// 各时间段的问候语
const timeGreetings = {
  [TimeOfDay.MORNING]: [
    "早上好！新的一天开始了 ☀️",
    "晨光正好，准备开始新的一天吗？ 🌅",
    "早安！今天想要完成什么呢？ ✨",
    "美好的早晨，让我们一起规划今天吧 🌤️",
    "早上好呀！精神饱满地迎接新挑战 💪"
  ],
  [TimeOfDay.AFTERNOON]: [
    "下午好！午后时光过得怎么样？ ☀️",
    "阳光正好，有什么可以帮你的吗？ 🌞",
    "下午好呀！需要整理一下今天的安排吗？ 📋",
    "午后时光，让我们聊聊接下来的计划 ⏰",
    "下午好！工作进展如何呢？ 💼"
  ],
  [TimeOfDay.EVENING]: [
    "晚上好！夜幕降临了呢 🌆",
    "晚安时光，今天过得怎么样？ 🌙",
    "晚上好呀！准备放松一下吗？ ✨",
    "夜幕降临，让我们总结一下今天吧 📝",
    "晚上好！有什么想聊的吗？ 💭"
  ],
  [TimeOfDay.LATE_NIGHT]: [
    "夜深了，还在忙碌吗？ 🌙",
    "深夜时分，夜猫子模式开启 🦉",
    "夜深了呢，记得早点休息哦 💤",
    "深夜好！有什么重要的事情吗？ ⭐",
    "夜深人静，适合思考和规划 🌌"
  ]
};

/**
 * 根据小时数判断时间段
 */
export const getTimeOfDay = (hour: number): TimeOfDay => {
  if (hour >= 6 && hour < 12) {
    return TimeOfDay.MORNING;
  } else if (hour >= 12 && hour < 18) {
    return TimeOfDay.AFTERNOON;
  } else if (hour >= 18 && hour < 23) {
    return TimeOfDay.EVENING;
  } else {
    return TimeOfDay.LATE_NIGHT;
  }
};

/**
 * 获取当前本地时间的小时数
 */
export const getCurrentHour = (): number => {
  const now = new Date();
  return now.getHours();
};

/**
 * 获取时间相关的问候语
 * @param probability 显示时间问候语的概率 (0-1)，默认0.3
 * @returns 时间相关的问候语，如果不符合概率或时间条件则返回null
 */
export const getTimeBasedGreeting = (probability: number = 0.3): string | null => {
  // 概率控制
  if (Math.random() > probability) {
    return null;
  }

  const currentHour = getCurrentHour();
  const timeOfDay = getTimeOfDay(currentHour);
  const greetings = timeGreetings[timeOfDay];
  
  // 随机选择一个问候语
  const randomIndex = Math.floor(Math.random() * greetings.length);
  return greetings[randomIndex];
};

/**
 * 检查当前是否为指定时间段
 */
export const isTimeOfDay = (targetTime: TimeOfDay): boolean => {
  const currentHour = getCurrentHour();
  const currentTimeOfDay = getTimeOfDay(currentHour);
  return currentTimeOfDay === targetTime;
};
